function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#e51;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_2-2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M0,5.71V4.42H1.5A.46.46,0,0,0,2,3.92V1.52H3.4v2.9H6.48V5.71H3.4v5.68c0,1.13.43,1.71,1.56,1.71H6.35v1.32H4.87a2.7,2.7,0,0,1-3-3V5.71Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M9.29,5.67A5.07,5.07,0,0,1,13,4.17a5,5,0,0,1,3.73,1.5,5.15,5.15,0,0,1,1.48,3.75A5.13,5.13,0,0,1,13,14.67,5.06,5.06,0,0,1,7.79,9.42,5.09,5.09,0,0,1,9.29,5.67Zm1.08,6.54A3.53,3.53,0,0,0,13,13.29a3.57,3.57,0,0,0,2.64-1.08,3.88,3.88,0,0,0,1-2.79,3.88,3.88,0,0,0-1-2.77A3.5,3.5,0,0,0,13,5.56a3.41,3.41,0,0,0-2.63,1.11,3.9,3.9,0,0,0-1,2.75A3.91,3.91,0,0,0,10.37,12.21Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M19.87,14.42V0h1.52V9.13h.11l4.29-4.71h1.92L24.08,8.31,28,14.42H26.23l-3.17-5-1.67,1.79v3.21Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M40.33,14.42v-10h1.52V5.88H42A3.25,3.25,0,0,1,45,4.17a3.46,3.46,0,0,1,2.71,1.14,4,4,0,0,1,1,2.83v6.28H47.23V8.23a2.51,2.51,0,0,0-.75-1.9,2.55,2.55,0,0,0-1.82-.73,2.68,2.68,0,0,0-2,.82,2.75,2.75,0,0,0-.81,2v6Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M38.34,8.62c0,.22,0,.44,0,.67V10H28.64m0,0a4.7,4.7,0,0,1,0-.54,5.29,5.29,0,0,1,.05-.8h9.67"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M50.06,4.83v-.4h1.79v.4h-.68V7h-.43V4.83ZM52.27,7V4.43h.43l1,2.05h.05l1-2.05h.43V7h-.42V5.33h0L53.86,7h-.35l-.8-1.71h0V7Z"
})));

function SvgTokNLogotype(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 55.1 14.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokNLogotype);
export default __webpack_public_path__ + "static/media/tok-n-logotype.eec09c1b.svg";
export { ForwardRef as ReactComponent };